import React from 'react';
import ReactLoading from 'react-loading';

const Loader = props => {
  return (
    <div className="form-container">
      <div className="panel-body">
        <p>Loading.....</p>
        <ReactLoading type="spin" color="#002f5f" height="200px" width="200px" />
      </div>
    </div>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loader.js